const MAXIMAL_DURATION_MOVIE = 40

const COUNTER_MOVIE_DESKTOP_CARD = 3
const COUNTER_MOVIE_TABLET_CARD = 2
const COUNTER_MOVIE_MOBILE_CARD = 2

const DISPLAY_XL = 1023
const DISPLAY_L = 767

const TWELVE = 12
const EIGHT = 8
const FIVE = 5

// Регулярное выражение для проверки коректного email
const PATTERN_REGEX_EMAIL = "[a-zA-Z0-9_.]+@[a-zA-Z0-9_]+\\.[a-z]{2,}"

export {
  MAXIMAL_DURATION_MOVIE,
  COUNTER_MOVIE_DESKTOP_CARD,
  COUNTER_MOVIE_TABLET_CARD,
  COUNTER_MOVIE_MOBILE_CARD,
  PATTERN_REGEX_EMAIL,
  DISPLAY_XL,
  DISPLAY_L,
  FIVE,
  EIGHT,
  TWELVE
}
